import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import Carousel from './Carousel'

import './gallery.css'

const Gallery = (props) => {
  const images = props.images.map((image, idx) => (
    <div key={idx} className={classnames({
      'content--image': true,
      'col-xs-6': !image.full_width,
      'col-xs-12 col-full': image.full_width
    })}>
      <img src={image.src} alt='' />
    </div>
  ))

  const carousel = !props.useMobileCarousel ? false : (
    <Carousel images={props.images} />
  )

  return (
    <div className='gallery'>
      <div className='gallery__images content-wrapper content row'>
        {images}
      </div>
      {carousel}
    </div>
  )
}

Gallery.propTypes = {
  images: PropTypes.array.isRequired,
  useMobileCarousel: PropTypes.bool
}

export default Gallery



// WEBPACK FOOTER //
// ./src/components/Page/Content/Gallery/index.js